import { useCrmLocale } from '../../ui/locale/crmLocale';
import {useEffect,useState} from 'react';
import {CrmSearchError} from '../../api/crmSearchTransport';

export default function CrmSearchSourceError({error,arabic,retry}:{error:unknown;arabic:boolean;retry:()=>void}) {
  const { t: crmText } = useCrmLocale();

  const [,tick]=useState(0);
  const known=error instanceof CrmSearchError?error:undefined;
  const retryAt=known?.code==='rate_limit'?known.retryAt:0;
  useEffect(()=>{
    if(retryAt<=Date.now())return;
    const timer=setInterval(()=>{tick(value=>value+1);if(Date.now()>=retryAt)clearInterval(timer);},1000);
    return ()=>clearInterval(timer);
  },[retryAt]);
  const seconds=Math.max(0,Math.ceil((retryAt-Date.now())/1000));
  let message=arabic?'مصدر البحث غير متاح حاليًا. حاول تاني.':'This search source is unavailable. Please retry.';
  if(known?.code==='rate_limit')message=seconds>0
    ? arabic?`طلبات البحث كتير مؤقتًا. أعد المحاولة بعد ${seconds} ثانية.`:`Too many searches. Retry in ${seconds} seconds.`
    : arabic?'تقدر تعيد محاولة البحث دلوقتي.':'You can retry the search now.';
  if(known?.code==='timeout')message=arabic?'البحث أخد وقت أطول من المتوقع. أعد المحاولة.':'Search timed out. Please retry.';
  if(known?.code==='access')message=arabic?'الوصول لمصدر البحث غير متاح لحسابك.':'Search access is unavailable for your account.';
  return <div role="alert"><p>{message}</p><button type="button" disabled={seconds>0} onClick={retry}>{arabic?crmText("إعادة المحاولة"):crmText("Retry")}</button></div>;
}
